export default __webpack_public_path__ + "static/media/my_current-location-blue.a5c0f845.svg";